/* eslint-disable */
var baseApiUrl = ''
var appBaseUrl = ''
var appId = "WgzsdBa3C9tpibNY"
if (process.env.NODE_ENV === 'production') {
  // baseApiUrl = 'https://discussion-tool-demo-api.geodemosolutions.com/public/'
  // appBaseUrl = 'https://discussion-tool-demo.geodemosolutions.com/#/'
  baseApiUrl = 'https://wpbts-collaboration-tool-api.geodemosolutions.com/public/'
  appBaseUrl = 'https://wpbts-collaboration-tool.geodemosolutions.com/#/'
 }
else {
  baseApiUrl = 'http://localhost/wpbts-discussion-tool-api/public/'
  appBaseUrl = 'http://localhost:6868/#/'
}

export {
  baseApiUrl,
  appBaseUrl,
  appId
}
